<div class="lessons-list">
    <div *ngFor="let lesson of lessons; let i = index" class="lesson-block" [ngClass]="{'active-lesson': enableEdit && enableEditIndex == i}" (click)="openTasks(i, lesson)">
        <div class="lesson" >
            <div class="lesson-info">
                <div class="lesson-i">
                    {{i+1}}
                </div>
                <div class="lesson-text">
                    <div class="lesson-name">{{lesson.name}}</div>
                    <div class="lesson-description">{{lesson.theory}}</div>
                    <a [routerLink]="['/theory', lesson.id]" class="theory-link">Читать больше</a>
                </div>
            </div>
            <div class="lesson-more" >
                <div class="circle-progress">
                    <circle-progress
                    [radius]="50"
                    [percent] = "(lesson.taskcount/lesson.totalcount)*100"
                    [maxPercent] = "100"
                    [unitsFontSize]="'24px'"
                    [titleFontSize]="'24px'"
                    [outerStrokeColor]="'#7D17FF'"
                    [unitsColor]="'#000000'"
                    [titleColor]="'#000000'"
                    [unitsFontWeight]="'bold'"
                    [titleFontWeight]="'bold'"
                    [animationDuration]="0"
                    [outerStrokeWidth]="6"
                    [space]="-6"
                    [showBackground]="false"
                    [showInnerStroke]="true"
                    [innerStrokeColor] = "'rgba(125, 23, 255, 0.07)'"
                    [showSubtitle]="false"
                    [clockwise]="false"
                    ></circle-progress>
                </div>
                <div class="show-more">
                    <div class="triangle-right"></div>
                </div>
            </div>
        </div>
        <ng-container *ngIf="enableEdit && enableEditIndex == i;">
            <div *ngFor="let task of lesson.tasks; let j=index" class="task">
                <div class="task-info">
                    <div class="task-i">
                        {{i+1}}.{{j+1}}
                    </div>
                    <div class="task-text">
                        <div [routerLink]="['run', task.id]" class="task-name">{{task.name}}</div>
                    </div>
                </div>
                <div class="task-more">
                    <div class="task-progress" >
                        <img *ngIf="task.completed && task.completed == 1; else tasklink" src="assets/img/icons/completed.svg" alt="">
                        <ng-template #tasklink>
                            <a [routerLink]="['run', task.id]" href="">Перейти</a>
                        </ng-template>
                    </div>
                    
                </div>
            </div>
        </ng-container>
    </div>
</div>